import React from "react";

const Overviewsection = ({
  image,
  title,
  description,
  buttontext,
  buttonlink,
}) => {
  return (
    <section className="hero-section-main d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center gy-4">
          {/* Left Image */}
          <div className="col-lg-6 hero-image text-center mt-lg-0">
            <div className="portfolio-device-mockups portfolio-details-img justify-content-start">
              <img src={image} alt={title} className="portfolio-hero-img" />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6 portfolio-hero-content">
            <h1 className="portfolio-hero-main-title">{title}</h1>
            <p className="portfolio-hero-description">{description}</p>

            <a href={buttonlink} className="btn btn-orange">
              {buttontext}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overviewsection;
